export const test = {
  state: {
    team: [
      { team: 1, name: "1队伍" },
      { team: 2, name: "2队伍" },
      { team: 3, name: "3队伍" },
      { team: 4, name: "4队伍" },
      { team: 5, name: "5队伍" },
      { team: 6, name: "6队伍" },
    ], // 所有队伍选中的队伍
  },
  reducers: {
    reset: (_, payload) => {
      console.warn("reset test model", payload);
      return payload;
    },
    // 互等
    setTeam: (start) => {
      return { ...start, team: 1 };
    },
  },
};

export const gameSession = {
  state: {
    session_uuid: null,
    // 0: 未开始, 50: 激活准备, 100: 进行中, 120: 暂停, 200: 结束, 300: 揭晓冠军, 400: 关闭场次
    status: 0,
  },
  reducers: {
    setSessionUUID: (state, payload) => {
      return { ...state, session_uuid: payload };
    },
    setStatus: (state, payload) => {
      return { ...state, status: payload };
    },
  },
};

export const qrCodeModal = {
  state: {
    visible: false,
    url: null,
    type: null,
    ext: null,
    onClose: null,
  },
  reducers: {
    show: (state, payload) => {
      return { ...state, visible: true, ...payload };
    },
    hide: (state) => {
      return { ...state, visible: false };
    },
  },
};

export const confirm = {
  state: {
    show: false,
    message: "",
    onConfirm: null,
    onClose: null,
  },
  reducers: {
    show: (_, payload) => ({
      show: true,
      message: payload.message,
      onConfirm: payload.onConfirm,
      onClose: payload.onClose,
    }),
    hide: () => ({
      show: false,
      message: "",
      onConfirm: null,
      onClose: null,
    }),
  },
};
